<!-- //
源端/目标端管理列表
@auth xuyd
@date 2024-11-26
//-->
<template>
	<div>
		<el-table ref="refTable" v-loading="tableLoading" :data="list" border size="small" :header-cell-style="this.tableHeader">
			<el-table-column header-align="left" label="参数名" align="left" width="150" prop="configName"> </el-table-column>
			<el-table-column header-align="left" label="参数值" align="left" min-width="200" prop="configValue"> </el-table-column>
			<el-table-column header-align="left" label="描述" align="left" min-width="100" prop="configRemark"> </el-table-column>
			<el-table-column header-align="left" label="操作" align="left" width="120" fixed="right">
				<template slot-scope="{ row }">
					<el-button size="small" type="text" @click="handleModify(row)" v-permission="['sys:multiEnvConfig:update']">编辑</el-button>
					<el-button size="small" type="text" @click="handleDelete(row)" v-permission="['sys:multiEnvConfig:delete']">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>
<script>
import MultiEnvApi from "@/api/sys/sysMultiEnv.api";

export default {
	name: "ViewTerminalSiteConfig",
	components: {},
	dictTypes: [
		{ dictType: "YES_OR_NO", dataType: Number }, // 有效状态
	],
	data() {
		return {
			// 遮罩层
			loading: false,

			// table数据
			tableLoading: false,
			list: this.configData,
			// 查询服务器
			queryParams: {
				pageNum: 1,
				pageSize: 20,
				orderByColumn: null,
				isAsc: null,
			},
		};
	},
	props: {
		configData: {
			type: Array,
			default: () => {
				return [];
			},
		},
	},
	watch: {
		configData(val) {
			this.list = val;
		},
	},
	methods: {
		/** 修改按钮操作 */
		handleModify(row) {
			this.$emit("edit", row);
		},
		/** 删除按钮操作 */
		handleDelete(row) {
			this.$modal.confirm(`确定要删除吗？`).then(() => {
				MultiEnvApi.deleteSiteDetail(row.id).then(() => {
					this.$emit("reload");
				});
			});
		},
	},
};
</script>

<style lang="less" scoped></style>
